module.exports = __webpack_public_path__ + "static/Familiar2-d0eb7dd8339de0a25d6d76a8f7a956e8.jpeg";